import { Link } from "react-router-dom";
import { BookOpen, Camera, Users } from "lucide-react";

const directions = [
  {
    label: "Shine",
    heading: "Show your work",
    description:
      "Browse galleries, enter quests, and submit your creative work for the community to see. Recognition starts here.",
    icon: Camera,
    color: "from-[#B6FCFF] to-[#00C3FF]",
    textColor: "text-[#007d91]",
    links: [
      { label: "Browse Gallery", to: "/gallery" },
      { label: "View Quest Schedule", to: "/quests" },
    ],
  },
  {
    label: "Refine",
    heading: "Grow your craft",
    description:
      "Access structured education, workshops, tutorials, and mentor guidance designed to build real creative skills.",
    icon: BookOpen,
    color: "from-[#e0f7fa] to-[#b2ebf2]",
    textColor: "text-[#00838f]",
    links: [
      { label: "Refine Education", to: "/refine" },
      { label: "Education", to: "/education" },
    ],
  },
  {
    label: "Uplift",
    heading: "Connect and support",
    description:
      "Read blogs, join the community, follow newsletters, and help fellow artists grow through shared experience.",
    icon: Users,
    color: "from-[#f3e5f5] to-[#e1bee7]",
    textColor: "text-[#6a1b9a]",
    links: [
      { label: "Community", to: "/community" },
      { label: "Read Blogs", to: "/blogs" },
    ],
  },
];

const ShineRefineUplift = () => (
  <section className="bg-white px-4 py-16">
    <div className="container m-auto">
      <div className="mb-10 text-center">
        <p className="font-outfit text-xs font-bold uppercase tracking-[0.18em] text-[#008aa0]">
          Three directions
        </p>
        <h2 className="mt-3 font-cinzel text-[32px] leading-tight text-[#101819] md:text-[48px]">
          Shine. Refine. Uplift.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl font-outfit text-base leading-7 text-[#536061]">
          Every path through LWBL leads one of three directions — toward visibility, toward growth,
          or toward community. Pick what you need most right now.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {directions.map(({ label, heading, description, icon: Icon, color, textColor, links }) => (
          <article
            key={label}
            className="flex flex-col justify-between rounded-2xl border border-gray-100 bg-white p-7 shadow-sm hover:shadow-md transition-shadow"
          >
            <div>
              <div className={`mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br ${color}`}>
                <Icon size={22} className={textColor} />
              </div>
              <p className={`font-outfit text-xs font-bold uppercase tracking-[0.18em] ${textColor}`}>
                {label}
              </p>
              <h3 className="mt-2 font-cinzel text-2xl text-[#111718]">{heading}</h3>
              <p className="mt-3 font-outfit text-sm leading-6 text-[#536061]">{description}</p>
            </div>
            <div className="mt-6 flex flex-wrap gap-2">
              {links.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className={`rounded-full border px-4 py-2 font-outfit text-xs font-semibold transition hover:opacity-80 ${textColor} border-current`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ShineRefineUplift;
